import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import type { SalesPromotionDto } from '@/services/ws-funnel/src/main/resources/rest-api';
import { SalesPromotionStatus } from '@/services/ws-funnel/src/main/resources/rest-api';
import { Tag } from '@/js/libs/ui';

interface PromotionStatusTagProps {
  promotion: SalesPromotionDto;
  className?: string;
}

export const PromotionStatusTag: React.FC<PromotionStatusTagProps> = ({ promotion, className }) => {
  const [t] = useTranslation(['backend']);
  const theme = useTheme();
  const color = React.useMemo(() => {
    switch (promotion.status) {
      case SalesPromotionStatus.ACTIVE:
        return theme.colors.positive100;
      case SalesPromotionStatus.INACTIVE:
        return theme.colors.grey70_1;
      case SalesPromotionStatus.CANCELED_STATUS:
        return theme.colors.critical100;
      default:
        return theme.colors.positive100;
    }
  }, [promotion.status, theme]);

  return <Tag color={color} className={className} value={t(`backend:${promotion.status}`)} />;
};
